import { breadcrumbSchema, clinicSchema } from "../structured-data-core";
import { clinicBySlug } from "../clinics";

/**
 * JSON-LD for a clinic's own page: one MedicalClinic node and the
 * breadcrumb. `crumbs` runs from the first level below Home to this page.
 */
export function getClinicStructuredData(slug: string, crumbs: { name: string; path: string }[]) {
  const clinic = clinicBySlug(slug);
  if (crumbs[crumbs.length - 1]?.path !== clinic.page) {
    throw new Error(`Clinic ${slug}: the last breadcrumb must be the clinic page ${clinic.page}`);
  }
  return [clinicSchema(clinic), breadcrumbSchema(crumbs)];
}

/** Breadcrumb for a clinic booking page, /schedule-a-consult/<slug>/. */
export function bookingPageCrumbs(name: string, path: string) {
  return [
    { name: "Schedule a Consult", path: "/schedule-a-consult/" },
    { name, path },
  ];
}
